<template>
  <div class="line-content" style="width: 100%" ref="line" :id="id">
    <div
      class="line-content--item"
      flex
      v-for="(item, idx) in optionsList"
      :key="idx"
    >
      <div
        flex
        v-for="(option, index) in item"
        :key="index"
        class="option-item"
        :style="getOptionsStyle(index, option)"
        :id="`${option.id}-${option.title}`"
        :class="{ isMobile: mobile }"
        :name="index === 0 ? 'source' : 'target'"
      >
        <div style="margin-right: 10px" class="questionSeq">
          {{ index === 0 ? uppercaseStr[idx] : lowercaseStr[idx] }}
        </div>
        <bc-view-common
          placeholder="点击编辑选项"
          :border="false"
          style="flex: 1; min-width: 0"
          :content="option.content"
          :fileInfo="option.fileInfo"
          :mobile="mobile"
          :isLineFile="mobile"
        ></bc-view-common>
      </div>
    </div>
    <!--    <div class="line-content&#45;&#45;item">-->
    <!--      <div flex v-for="(item, index) in optionsList.right" :key="index" class="option-item">-->
    <!--        <div style="margin-right: 10px;line-height: 40px">{{ item.title }}</div>-->
    <!--        <bc-view-common  placeholder="点击编辑选项"-->
    <!--                         :content="item.content" :fileInfo="item.fileInfo"-->
    <!--        ></bc-view-common>-->
    <!--      </div>-->

    <!--    </div>-->
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
// import { jsPlumb } from 'jsplumb'
import XEUtils from "xe-utils";
const lowercaseStr = "abcdefghijklmnopqrstuvwxyz".split("");
const uppercaseStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const colors = [
  "rgba(240,63,36,0.55)",
  "rgba(92,34,35,0.42)",
  "rgba(240,124,130,0.7)",
  "rgba(122,115,116,0.76)",
  "rgba(238,184,195,0.8)",
  "rgba(99,7,28,0.62)",
  "rgba(126,22,113,0.56)",
  "rgba(46,49,124,0.68)",
  "#61649f",
  "#0f59a4",
  "#619ac3",
  "#c4cbcf",
  "#22a2c3",
  "#21373d",
  "#12a182",
  "#1a3b32",
  "#41ae3c",
  "#bec936",
  "#fed71a",
  "#ffa60f",
  "#4d4030",
  "#954416",
  "#363433",
  "#652b1c",
  "#ed3333",
];
export default {
  name: "bc-line-question-view-line",
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    options: {
      handler(val) {
        this.optionsList = val.map((i) =>
          i.map((x) => ({ ...x, id: uuidv4() }))
        );
      },
      immediate: true,
    },
    optionsList: {
      handler(val) {
        let left = val.map((i) => i[0].title);
        let right = val.map((i) => i[1].title);
        this.left = left;
        this.right = right;
        // this.loadLine()
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      lowercaseStr,
      uppercaseStr,
      optionsList: [],
      instance: null,
      id: "",
      colors,
      left: [],
      right: [],
    };
  },
  created() {
    this.id = uuidv4() + "--line";
  },
  mounted() {
    // this.loadLine()
  },
  methods: {
    getOptionsStyle(index, option) {
      if (index === 0) {
        let colorIndex = this.colors[this.left.indexOf(option.title)];
        return {
          background: colors[this.left.indexOf(option.title)] + " !important",
        };
      } else {
        let colorIndex = this.left.indexOf(option.title.toLocaleUpperCase());
        return { background: colors[colorIndex] + " !important" };
      }
    },
    loadLine() {
      // this.$nextTick(() => {
      //   let contents = XEUtils.flatten(XEUtils.flatten(this.optionsList.map(i => i.map(x => this.getImgSrc(x.content)))))
      //
      //   let promiseAll = []
      //
      //   let img = []
      //   for (let i = 0; i < contents.length; i++) {
      //     promiseAll[i] = new Promise((resolve, reject) => {
      //       img[i] = new Image();
      //       img[i].src = contents[i];
      //       img[i].onload = function() {
      //         resolve(this);
      //       };
      //     });
      //   }
      //   if (promiseAll.length) {
      //     Promise.all(promiseAll).then(img => {
      //       this.init()
      //     });
      //   } else {
      //     setTimeout(() => {
      //       this.init()
      //     }, 500)
      //   }
      //
      // })
    },
    getImgSrc(rich) {
      let imgList = [];
      rich.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
        imgList.push(capture);
      });
      return imgList;
    },
    init() {
      this.instance = jsPlumb.getInstance({
        Container: this.id,
        EndpointStyle: { radius: 0.11, fill: "#999" },
        PaintStyle: { stroke: "#999", strokeWidth: 2 }, // 绘画样式，默认8px线宽  #456
        HoverPaintStyle: { stroke: "#994B0A", strokeWidth: 3 }, // 默认悬停样式  默认为null
        ConnectionOverlays: [
          // 此处可以设置所有箭头的样式
          [
            "Arrow",
            {
              // 设置参数可以参考中文文档
              location: 1,
              length: 12,
              paintStyle: {
                stroke: "#999",
                fill: "#999",
              },
              visible: false,
            },
          ],
        ],
        Connector: ["Straight"], // 要使用的默认连接器的类型：直线，折线，曲线等
        DrapOptions: { cursor: "crosshair", zIndex: 2000 },
      });

      this.instance.batch(() => {
        for (let i = 0; i < this.optionsList.length; i++) {
          this.initElement(this.optionsList[i][0], "source");
          this.initElement(this.optionsList[i][1], "target");
        }
      });
      this.setjsPlumb(true, true);

      this.instance.ready(() => {
        this.setConnect();
      });
    },
    setConnect() {
      let left = this.optionsList.map((i) => i[0]);
      let right = this.optionsList.map((i) => i[1]);
      left.forEach((el) => {
        let rightIndex = right.findIndex(
          (i) => i.title === el.title.toLocaleLowerCase()
        );
        this.instance.connect({
          source: el.id + "-" + el.title,
          target: right[rightIndex].id + "-" + right[rightIndex].title,
        });
      });
    },
    initElement(option, type) {
      const ins = this.instance;
      const elem = document.getElementById(option.id + "-" + option.title);

      if (type === "source") {
        ins.makeSource(elem, {
          anchor: [1, 0.5, 0, 0], // 左 上 右 下
          allowLoopback: false, // 允许回连
          maxConnections: 1, // 最大连接数（-1表示不限制）
        });
      } else {
        ins.makeTarget(elem, {
          anchor: [0, 0.5, 0, 0],
          allowLoopback: false,
          maxConnections: 1,
        });
      }
    },
    setjsPlumb(sourceFlag, targetFlag) {
      const source = document.getElementsByName("source");
      const target = document.getElementsByName("target");

      this.instance.setSourceEnabled(source, sourceFlag);
      this.instance.setTargetEnabled(target, targetFlag);
      this.instance.setDraggable(source, false); // 是否支持拖拽
      this.instance.setDraggable(target, false); // 是否支持拖拽
    },
  },
};
</script>

<style scoped lang="scss">
.line-content {
  width: 100%;
  position: relative;
  .line-content--item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    ::v-deep .stem-content {
      height: 100%;
    }
  }

  & + .line-content {
    margin-top: 10px;
  }
  //.line-content--item + .line-content--item {
  //  margin-left: 100px;
  //}
}
//.line-content--item + .line-content--item {
//}
.option-item + .option-item {
  //margin-top: 10px;
}
.create-option {
  width: 100%;
  margin-top: 10px;
  border-style: dashed !important;
}

.option-item {
  min-width: 0;
  width: 300px;
}

.option-item + .option-item {
  margin-left: 100px;
}
.option-item.isMobile + .option-item.isMobile {
  margin-left: 50px;
}
.option-item {
  margin-bottom: 10px;
  background: #fbfbfb;
  border-radius: 6px;
  padding-left: 16px;

  .questionSeq {
    padding: 8px 0;
  }
  ::v-deep .stem-content {
    &.no-border {
      padding: 8px 14px !important;
    }
  }
}
</style>
